import { bankAccountApi } from '../../api'
import { useAuthQuery } from '../../hooks/use-auth-query'

export function useGetExternalBankAccounts(enabled = false) {
  return useAuthQuery({
    queryKey: ['external-bank-accounts'],
    enabled,
    queryFn: bankAccountApi.getExternalBankAccounts,
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
  })
}
